export default "__VITE_ASSET__C8QGYnWY__"